import {	LOGOUT_MUTATION,UPDATE_TOKEN_MUTATION } from './graphql/authenticationQueries.js';
import {	authenticationClient } from './graphql/apolloClient';


class TokenAuthenticator {
	#memoryToken
	#expiryDate

	constructor() {
		this.#memoryToken = null;
		this.#expiryDate = null;
	}

	storeToken(accessToken, accessTokenExpirySeconds) {
		this.#memoryToken = accessToken;

		// Set expiry time to 3/4 (75%) of token timeout. So that token never expire before expiryDate.
		let expirySeconds = (accessTokenExpirySeconds * 3) / 4;

		// Calculate new expiry date
		this.#expiryDate = new Date(Date.now() + expirySeconds * 60 * 1000);
	}

	async updateToken() {
		const result = await authenticationClient.mutate({
			mutation: UPDATE_TOKEN_MUTATION
		});

		// Update of token success, store new token
		if (result.data.updateToken.status == "OK" && result.data.updateToken) {
			this.storeToken(result.data.updateToken.accessToken, result.data.updateToken.accessTokenExpirySeconds);
			return result.data.updateToken.accessToken;
		} else // Update of token with refresh token failed, must redirect to login 
		{
			await this.logout();
			return null;
		}
	}

	getToken() {
		if (this.#memoryToken && new Date() < new Date(this.#expiryDate)) {
			return this.#memoryToken;
		} else {
			return null;
		}
	}

	tokenExpired() {
		if (this.#expiryDate != null && this.#memoryToken != null) {
			return (new Date() > new Date(this.#expiryDate));
		} else {
			return true;
		}
	}

	async logout() {

		if(this.#memoryToken != null && this.#expiryDate != null)
		{
			await authenticationClient.mutate({
				mutation: LOGOUT_MUTATION
			});

			this.#memoryToken = null;
			this.#expiryDate = null;
		}
	}

}

export const tokenAuthenticator = new TokenAuthenticator();